import { CommunicationCategory, TimelineFilterType } from '@bariendo/lib/constants';

/**
 * Which Communication categories each timeline filter shows.
 *
 * Load-bearing twice: it supplies the `categories` variable of the timeline
 * GraphQL query *and* filters the fetched registers client-side. A category
 * missing from a filter's list is not fetched under that filter — and a category
 * missing from `ALL` is not fetched at all, which reads as "the card does not
 * exist" rather than as an error. Adding a timeline Communication category means
 * adding it here too.
 *
 * Lives in its own module so it can be asserted on without importing the
 * timeline hook, which pulls in Medplum, GraphQL and router context.
 */
export const FILTER_CATEGORY_MAP: Record<string, string[]> = {
  [TimelineFilterType.ALL]: [
    CommunicationCategory.PHONE_CALL,
    CommunicationCategory.SMS_MESSAGE,
    CommunicationCategory.TIMELINE_NOTE,
    CommunicationCategory.STANDALONE_NOTE,
    CommunicationCategory.CHAT,
    CommunicationCategory.LAB_ORDER,
    CommunicationCategory.INBOUND,
    CommunicationCategory.FAX_MESSAGE,
    CommunicationCategory.PAC_INTRO_CALL_NOTE,
    CommunicationCategory.PAC_WARM_HANDOFF_NOTE,
  ],
  [TimelineFilterType.COMMUNICATIONS]: [
    CommunicationCategory.PHONE_CALL,
    CommunicationCategory.SMS_MESSAGE,
    CommunicationCategory.CHAT,
    CommunicationCategory.TIMELINE_NOTE,
    CommunicationCategory.INBOUND,
    CommunicationCategory.FAX_MESSAGE,
  ],
  [TimelineFilterType.DOCUMENTATION]: [
    CommunicationCategory.STANDALONE_NOTE,
    CommunicationCategory.TIMELINE_NOTE,
    // The CI call cards are chart notes, not calls: the answers the rep records
    // are the documentation, and the call recording has its own card.
    CommunicationCategory.PAC_INTRO_CALL_NOTE,
    CommunicationCategory.PAC_WARM_HANDOFF_NOTE,
  ],
  [TimelineFilterType.CARE_CLINICAL]: [CommunicationCategory.LAB_ORDER, CommunicationCategory.TIMELINE_NOTE],
};
